import * as React from "react";
import { makeStyles } from "@material-ui/core";
import palette from "../../theme/palette";
import { Dialog, DialogActions, TextareaAutosize } from "@mui/material";
import NewButton from "../../components/NewButton";

const useStyles = makeStyles((theme) => ({
  stepperInput: {
    width: "144px",
    // height: "76px",
    padding: "15px 8px",
    "@media  (max-width: 786px) and (min-width: 100px)": {
      width: "100%",
    },
  },
  stepperField: {
    border: 9,
    width: "100%",
    padding: "5px",
    outlineColor: "blue"
  },
  stepperFieldMobile: {
    border: 9,
    width: "100%",
    padding: "5px",
    outline: "none"
  },
  stepperText: {
    fontSize: "16px",
    lineHeight: "18px",
    fontWeight: 400,
    color: palette.primary.light,
    padding: "0",
    margin: 0,
    width: '98px',
    wordWrap: "break-word",
    whiteSpace: "break-spaces",
    // height: "74px",
    "@media  (max-width: 786px) and (min-width: 100px)": {
      width: "100%",
      fontSize: "14px",
      lineHeight: "16.8px",
      wordBreak: "break-word"
    },
    ".dark-mode &": {
      color: "var(--color-text-secondary)"
    }
  },
}));

interface EditOutcomeStatusModal {
  showInput: boolean;
  index: number;
  textInput: any;
  onValueChange: (e: any) => void;
  editStatus: number;
  isMobile?: boolean
  absenceToggle?: boolean
  setShowInput?: (showInput: boolean) => void;
  setEditStatus?: (editStatus: number) => void;
}

const EditOutcomeStatusNew = (props: EditOutcomeStatusModal) => {
  const classes = useStyles();
  console.log("props.showInput && props.editStatus === props.index", props.showInput && props.editStatus === props.index);

  return (
    <>
      {props.showInput && props.editStatus === props.index ? (
        props?.isMobile ?
          <div className={classes.stepperInput + "hide-scrollbar"}>
            <TextareaAutosize
              autoFocus
              name={props.absenceToggle ? (props.index - 1 + "") : props.index + ""}
              // type="text"
              minRows={props?.isMobile ? 1 : 4}
              cols={props.isMobile ? 100 : 0}
              className={props?.isMobile ? classes.stepperFieldMobile : classes.stepperField}
              value={props.textInput[props?.index]?.text}
              onChange={(e) => props.onValueChange(e)}
            />

          </div> : <InputEntryModal {...props} />

      ) : (
        <div style={!props?.isMobile ? {
          backgroundColor: "var(--white-background)",
          color: "var(--color-text-primary)",
        } : {
          width: "100%",
          height: "100%",
          display: "flex",
          minHeight: "34px",
          alignItems: "center"
        }} onClick={() => {
          if (props.isMobile && (props.absenceToggle ? (props.index - 1) : props.index) >= 0) {
            props.setShowInput(true);
            props.setEditStatus(props.index);
          }
        }}>
          <p className={classes.stepperText} >
            {props.textInput[props?.index]?.text}
          </p>
        </div>

      )}
    </>
  );
};
export default EditOutcomeStatusNew;

const InputEntryModal = (props) => {
  const [modalOpen, setModalOpen] = React.useState(false)
  React.useEffect(() => {
    if (props.showInput && props.editStatus === props.index) {
      setModalOpen(true)
    } else {
      setModalOpen(false)
    }
  }, [props.showInput, props.editStatus, props.index])
  return <Dialog
    open={modalOpen}
    onClose={() => props.setShowInput(false)}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    sx={{
      zIndex: 99999,
      "& .MuiDialog-paper": {
        maxWidth: "calc(100vw - 30%)",
        maxHeight: "calc(100vh - 10%)",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        borderRadius: "16px"
      }
    }}
  // className={classes.categoryDialog}
  >
    <TextareaAutosize
      autoFocus
      name={props.absenceToggle ? (props.index - 1 + "") : props.index + ""}
      // type="text"
      // rows={props?.isMobile ? 1 : 4}
      minRows={4}
      cols={60}
      // className={props?.isMobile ? classes.stepperFieldMobile : classes.stepperField}
      value={props.textInput[props?.index]?.text}
      onChange={(e) => props.onValueChange(e)}
    />
    <DialogActions
      sx={{ mt: "30px", display: "flex", alignItems: "center", justifyContent: "center" }}
    // className={classes.categoryDialogAction}
    >
      <NewButton
        type="submit"
        variant="contained"
        onClick={() => props?.setShowInput(false)}
        buttonText="Save"
      />
    </DialogActions>
  </Dialog>
}